// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shimmer[data-v-eb82e50a]{width:100%;height:100%;position:relative;overflow:hidden}.shimmer[data-v-eb82e50a]::before{content:\"\";position:absolute;top:0;left:-100%;width:100%;height:100%;background:linear-gradient(90deg, transparent 25%, rgba(255, 255, 255, 0.2) 50%, transparent 75%);background-size:200% 100%;animation:shimmer-data-v-eb82e50a 1.5s infinite}@keyframes shimmer-data-v-eb82e50a{0%{left:-100%}100%{left:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
